import { graphql, useStaticQuery } from 'gatsby';

import { MetadataMeta } from '../types/gatsby-site';

export interface SiteMetadataQuery {
  site: {
    siteMetadata: MetadataMeta;
  };
}

const useSiteMetadata = () => {
  const { site } = useStaticQuery<SiteMetadataQuery>(
    graphql`
      query useSiteMetadataQuery {
        site {
          siteMetadata {
            blogPostsPerPage
            cmsUrl
            grecaptchaSiteKey
            favicon
            metaImage
            product
            siteDomain
            siteName
            siteUrl
            title
          }
        }
      }
    `,
  );

  return site.siteMetadata;
};

export default useSiteMetadata;
